<arpio-center-panel>
  <h3 class="panel-title">Oops...</h3>
  @if (errorDescription) {
    <div class="margin-top">{{ errorDescription }}</div>
  } @else {
    <div class="margin-top">An error occurred while processing your Azure Marketplace subscription request.</div>
  }
  <div class="margin-top">
    Please go back to the Azure Marketplace and find {{ uiService.productName }} under "Your Products". You should then
    be able to navigate back here with a valid subscription.
  </div>
  <div class="margin-top">For additional help, contact {{ uiService.supportContact }}.</div>
</arpio-center-panel>
